import React from 'react';
// import PropTypes from 'prop-types';
// import { connect } from 'react-redux';
// import InlineHelpGetter from 'data/inline-help/getters';
import ViewWrapper from './ViewWrapper';
// import Utils from '../../utils/util';

// eslint-disable-next-line react/no-unsafe
class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.redirect = this.redirect.bind(this);
    this.currentView = this.currentView.bind(this);
    this.getconf = this.getconf.bind(this);
    this.log = this.log.bind(this);
    this.viewWrapperRef = React.createRef();
    const { ModuleName, View } = this.props;
    this.state = {
      Screen: { ModuleName, View, Props: {} },
    };
  }

  // Wiki to use Api.getconf method:
  // https://confluence.collegeboard.org/pages/viewpage.action?spaceKey=POWERFAIDS&title=CBForm+Integration+with+Data+Dictionary+and+MadcapFlare
  getconf(key, tokenArray, statusCode, entityName) {
    // const { Attributes } = this.props;
    // if (key === 'menu') {
    //   if (Attributes.configuration && Attributes.configuration.hasOwnProperty) {
    //     return Attributes.configuration[key];
    //   }
    // } else {
    //   const { MCF } = this.props;
    //   return Utils.getConfHelper({ key, tokenArray, statusCode, entityName, MCF });
    // }
    // return null;
  }

  getViewWrapper(screen) {
    const { Api, Attributes, InstanceName } = this.props;
    const comp = React.createElement(ViewWrapper, {
      ref: this.viewWrapperRef,
      Api: { ...Api, log: this.log, getconf: this.getconf, currentView: this.currentView },
      Attributes,
      InstanceName,
      key: new Date().getTime(),
      screen,
    });
    return comp;
  }

  log(message, severity = 'Error') {
    const { InstanceName } = this.props;
    console.log(`Module Instance: ${InstanceName} ${new Date().toISOString()} : ${severity}:${message}`);
  }

  redirect(view, props = {}) {
    if (this.viewWrapperRef && this.viewWrapperRef.current) {
      this.viewWrapperRef.current.redirect(view, props);
    }
  }

  showViewModal(view, props = {}) {
    if (this.viewWrapperRef && this.viewWrapperRef.current) {
      this.viewWrapperRef.current.showViewModal(view, props);
    }
  }

  currentView() {
    const { View } = this.props;
    if (this.viewWrapperRef && this.viewWrapperRef.current) {
      return this.viewWrapperRef.current.currentView();
    }
    return View;
  }

  buildLayout(InsertComp) {
    const { Api, Attributes } = this.props;
    const { Screen } = this.state;
    const moduleLayout = Api.module.layout;
    const builtLayout = React.createElement(moduleLayout, {
      ModuleName: Screen.ModuleName,
      Api: { ...Api, redirect: this.redirect, log: this.log, getconf: this.getconf, currentView: this.currentView },
      Attributes,
      Comp: InsertComp,
      key: new Date().getTime(),
      Screen,
    });
    return builtLayout;
  }

  render() {
    const { Screen } = this.state;
    const moduleOut = this.buildLayout(this.getViewWrapper(Screen));
    return <div className="internal-view">{moduleOut}</div>;
  }
}

export default Layout;
